import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
import './login.css'
import Cookies from 'js-cookie';
import { NetGet, NetPost } from '../../axios'
import { toast } from 'react-toastify'

class Login extends Component{
    opencode=true
    componentDidMount(){
        this.codeimg.onclick=()=>{
           this.resetcode()
        }
       
    }

    resetcode=()=>{
        this.codeimgsrc.setAttribute("src",`/login/code?${new Date().getTime()}`)
    }

    submitLogin=()=>{
        if(!this.opencode){
            return false
        }
        if(!this.username.value||!this.password.value||!this.code.value){
           return toast.info("都必须填写哦 !");
        }
        this.opencode=false

        let param = new URLSearchParams()
        param.append('username', this.username.value)

        param.append('password', this.password.value)
        param.append('code', this.code.value)
        NetPost("/login", param)
            .then((e) => {
                this.opencode=true
                if (e.code == 0) {
                    Cookies.set('userinfo', e.data, { expires: 1000 })
                    toast.success(e.msg);
                   this.props.goLoction && this.props.goLoction()
                    this.props.setLogin&&this.props.setLogin(false)
                } else {
                    toast.error(e.msg);
                    this.resetcode()
                }


            })
            .catch((e) => {
                this.opencode=true

                toast.error("异常出错 !");
            })
    }
    render(){
        return(
            <div className="login-box">
                <div className="login-child-box">

                
                    <div>
                    <input ref={(ref)=>this.username=ref}/>
                    <i className="fe fe-user"></i>
                    </div>
                    <div>
                    <input ref={(ref)=>this.password=ref} type="password"/>
                    <i className="fe fe-lock"></i>
                    </div>
                    <div>
                    <input ref={(ref)=>this.code=ref} placeholder="请输入验证码"/>
                    <div ref={(ref)=>this.codeimg=ref} className="codeimg">
                    <img ref={(ref)=>this.codeimgsrc=ref} src={"/login/code"}/>

                    </div>
                    </div>
                </div>
                <div>
                    <button className="layui-btn admin-button" onClick={this.submitLogin}>登 陆</button>

                </div>
            </div>
        )
    }
}


export default Login